import image1 from '../../../assets/projectDetails/testimonial1.png';
import image2 from '../../../assets/projectDetails/testimonial2.png';
import image3 from '../../../assets/projectDetails/testimonial2.png';

export const fakeData = [
    {
        id: 1,
        img: image1,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
    {
        id: 2,
        img: image2,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
    {
        id: 3,
        img: image3,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
    {
        id: 4,
        img: image1,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
    {
        id: 5,
        img: image2,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
    {
        id: 6,
        img: image3,
        title: 'Profesional',
        content: 'Amet minim mollit non deserunt ullamco est sit aliqua minim mollit.'
    },
]